import { render } from "./wEmpty.vue?vue&type=template&id=848ff43c&ts=true"
import script from "./wEmpty.vue?vue&type=script&lang=ts"
export * from "./wEmpty.vue?vue&type=script&lang=ts"

import exportComponent from "E:\\Work\\Sales point\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__